<div class="sav-site-shell">
  <!--
    FIRST in the shell, not last.
  
    It is `position: fixed`, so where it sits in the source does not decide where it appears —
    but it does decide when it is parsed, and this element is the page's Largest Contentful
    Paint. Its paragraph is the biggest painted box on a phone (29,625px vs the h1's 11,076), so
    LCP is whenever this paints. Sitting at the end of a 472 KB document it was parsed 111 KB
    after the h1 and painted 1,652ms later, which put mobile LCP at 3.5s.
  
    Mounted once here rather than per page, so a visitor who navigates before answering is not
    asked again on the next route. It renders nothing at all once a choice is stored.
  -->
  <app-cookie-banner />
  <!-- ApexlyStore-style header (deals page only) — keeps the SavingArena logo. -->
  <!-- Desktop chrome runs from `xl` (1280px), which is where most laptops sit — and at 1280x800 the
       full-size header ate 164px of an 800px viewport. Everything below is therefore sized for the
       compact 1280-1535px tier, with the original, roomier values restored at `2xl` (1536px+). -->
  <div class="hidden bg-orange text-white xl:block">
    <div
      class="sav-site-container flex h-8 items-center justify-end gap-4 text-[11px] 2xl:h-9 2xl:gap-5 2xl:text-[12px]"
    >
      <a routerLink="/contact-us" class="hover:text-white/80">Contact Us</a>
      <a routerLink="/blogs" class="hover:text-white/80">Blog</a>
      <a routerLink="/why-trust-us" class="hover:text-white/80">Why Trust Us</a>
    </div>
  </div>
  <!-- `data-site-header` is a styling-free hook. Pages that park something directly beneath the
       header (the event page's sticky category band) measure this element's bottom edge to know
       where "beneath" is. It carries no CSS on purpose, so adding or changing header styling can
       never silently break that measurement. -->
  <header
    data-site-header
    class="sticky top-0 z-50 bg-white shadow-[0_2px_14px_rgba(17,17,17,0.07)]"
  >
    <div class="sav-site-container">
      <!-- Desktop row -->
      <div class="hidden h-[62px] items-center gap-5 xl:flex 2xl:h-[86px] 2xl:gap-7">
        <a
          routerLink="/"
          class="flex h-11 shrink-0 items-center 2xl:h-16"
          aria-label="SavingArena home"
        >
          <svg
            class="w-[230px] max-w-full 2xl:w-[305px]"
            viewBox="0 0 305 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M15.646 12.37H9.03797C3.52197 12.37 0.749974 10.634 0.749974 7.16199V6.06999C0.749974 2.56999 3.52197 0.861987 9.03797 0.861987H11.838C12.734 0.861987 12.93 1.36599 12.93 2.37399C12.93 3.38199 12.734 3.88599 11.838 3.88599H8.95397C5.67797 3.88599 4.44597 4.83799 4.44597 6.06999V7.16199C4.44597 8.36599 5.67797 9.34599 8.95397 9.34599H15.562C21.078 9.34599 23.85 11.082 23.85 14.554V15.954C23.85 19.454 21.078 21.162 15.562 21.162H1.84197C0.945974 21.162 0.749974 20.658 0.749974 19.65C0.749974 18.642 0.945974 18.138 1.84197 18.138H15.646C18.922 18.138 20.154 17.186 20.154 15.954V14.554C20.154 13.35 18.922 12.37 15.646 12.37ZM41.1853 0.777986C42.2773 0.777986 42.9213 1.14199 43.3693 1.75799L55.5773 19.174C55.7173 19.398 55.7733 19.622 55.7733 19.818C55.7733 20.658 54.6813 21.302 53.7293 21.302C53.2253 21.302 52.7773 21.134 52.4973 20.742L49.1933 15.926H33.6253L30.5173 20.742C30.2653 21.134 29.7893 21.302 29.3133 21.302C28.3893 21.302 27.2973 20.658 27.2973 19.79C27.2973 19.566 27.3813 19.37 27.4933 19.174L38.9733 1.75799C39.3933 1.14199 40.0653 0.777986 41.1853 0.777986ZM41.1853 4.19399L35.5573 12.902H47.1213L41.1853 4.19399ZM67.8213 21.274C66.7293 21.274 66.0853 20.938 65.6373 20.294L53.3173 2.87799C53.1773 2.65399 53.0933 2.45799 53.0933 2.23399C53.0933 1.42199 54.2693 0.749986 55.2493 0.749986C55.7253 0.749986 56.3133 0.917986 56.5933 1.33799L67.9053 17.606L79.1053 1.33799C79.3573 0.945986 79.8053 0.749986 80.3373 0.749986C81.2893 0.749986 82.4373 1.39399 82.4373 2.26199C82.4373 2.48599 82.3533 2.70999 82.2133 2.87799L70.0333 20.294C69.5853 20.938 68.9133 21.274 67.8213 21.274ZM90.6208 2.06599V19.958C90.6208 21.022 89.9768 21.274 88.7448 21.274C87.5408 21.274 86.8968 21.022 86.8968 19.958V2.06599C86.8968 1.00199 87.5408 0.749986 88.7448 0.749986C89.9768 0.749986 90.6208 1.00199 90.6208 2.06599ZM119.393 21.274C118.385 21.274 118.161 21.134 117.181 20.322L99.7645 5.64999V19.958C99.7645 21.022 99.1205 21.274 97.8885 21.274C96.6845 21.274 96.0405 21.022 96.0405 19.958V2.06599C96.0405 1.02999 96.6565 0.749986 97.8045 0.749986C99.0365 0.749986 99.5685 1.05799 100.437 1.78599L117.601 16.402V2.06599C117.601 1.00199 118.245 0.749986 119.449 0.749986C120.681 0.749986 121.325 1.00199 121.325 2.06599V19.958C121.325 21.05 120.681 21.274 119.393 21.274ZM151.595 10.97V15.954C151.595 19.51 148.683 21.162 143.279 21.162H134.795C129.279 21.162 126.507 19.426 126.507 15.954V6.06999C126.507 2.56999 129.279 0.861987 134.795 0.861987H138.743C139.639 0.861987 139.835 1.36599 139.835 2.37399C139.835 3.38199 139.639 3.88599 138.743 3.88599H134.907C131.631 3.88599 130.203 4.83799 130.203 6.06999V15.954C130.203 17.158 131.631 18.138 134.907 18.138H143.167C146.443 18.138 147.843 17.158 147.843 15.954V10.97C147.843 9.87799 148.459 9.65399 149.691 9.65399C150.923 9.65399 151.595 9.87799 151.595 10.97ZM168.634 0.777986C169.726 0.777986 170.37 1.14199 170.818 1.75799L183.026 19.174C183.166 19.398 183.222 19.622 183.222 19.818C183.222 20.658 182.13 21.302 181.178 21.302C180.674 21.302 180.226 21.134 179.946 20.742L176.642 15.926H161.074L157.966 20.742C157.714 21.134 157.238 21.302 156.762 21.302C155.838 21.302 154.746 20.658 154.746 19.79C154.746 19.566 154.83 19.37 154.942 19.174L166.422 1.75799C166.842 1.14199 167.514 0.777986 168.634 0.777986ZM168.634 4.19399L163.006 12.902H174.57L168.634 4.19399ZM187.675 2.14999C187.675 1.28199 188.095 0.861987 188.991 0.861987H204.727C209.795 0.861987 212.959 2.65399 212.959 5.39799V8.92599C212.959 11.67 209.795 13.462 204.727 13.462H203.607C200.303 13.462 198.959 13.434 197.503 13.35V13.406C198.707 13.854 199.995 14.274 204.251 15.982L210.999 18.698C211.643 18.95 211.895 19.342 211.895 19.958C211.895 20.966 211.223 21.274 209.991 21.274C209.459 21.274 208.367 21.218 207.779 20.882L191.399 13.798V19.958C191.399 21.022 190.755 21.274 189.523 21.274C188.319 21.274 187.675 21.022 187.675 19.958V2.14999ZM204.391 3.88599H191.399V10.494H204.391C208.199 10.494 209.263 9.70999 209.263 8.70199V5.67799C209.263 4.66999 208.199 3.88599 204.391 3.88599ZM239.681 12.678H221.509V15.954C221.509 17.158 222.937 18.138 226.213 18.138H239.597C240.493 18.138 240.689 18.642 240.689 19.65C240.689 20.63 240.493 21.162 239.597 21.162H226.101C220.585 21.162 217.813 19.426 217.813 15.954V6.06999C217.813 2.56999 220.585 0.861987 226.101 0.861987H230.273C231.141 0.861987 231.337 1.36599 231.337 2.37399C231.337 3.38199 231.141 3.88599 230.273 3.88599H226.213C222.937 3.88599 221.509 4.83799 221.509 6.06999V9.65399H239.681C240.577 9.65399 240.773 10.158 240.773 11.166C240.773 12.174 240.577 12.678 239.681 12.678ZM269.182 21.274C268.174 21.274 267.95 21.134 266.97 20.322L249.554 5.64999V19.958C249.554 21.022 248.91 21.274 247.678 21.274C246.474 21.274 245.83 21.022 245.83 19.958V2.06599C245.83 1.02999 246.446 0.749986 247.594 0.749986C248.826 0.749986 249.358 1.05799 250.226 1.78599L267.39 16.402V2.06599C267.39 1.00199 268.034 0.749986 269.238 0.749986C270.47 0.749986 271.114 1.00199 271.114 2.06599V19.958C271.114 21.05 270.47 21.274 269.182 21.274ZM289.456 0.777986C290.548 0.777986 291.192 1.14199 291.64 1.75799L303.848 19.174C303.988 19.398 304.044 19.622 304.044 19.818C304.044 20.658 302.952 21.302 302 21.302C301.496 21.302 301.048 21.134 300.768 20.742L297.464 15.926H281.896L278.788 20.742C278.536 21.134 278.06 21.302 277.584 21.302C276.66 21.302 275.568 20.658 275.568 19.79C275.568 19.566 275.652 19.37 275.764 19.174L287.244 1.75799C287.664 1.14199 288.336 0.777986 289.456 0.777986ZM289.456 4.19399L283.828 12.902H295.392L289.456 4.19399Z"
              fill="#741FA2"
            />
          </svg>
        </a>
        <form
          role="search"
          (submit)="onSearchSubmit($event)"
          class="relative flex h-[42px] w-full max-w-[520px] flex-1 items-center rounded-[10px] border border-[#cfcfd3] bg-white pl-4 text-[#333] transition focus-within:border-orange focus-within:ring-2 focus-within:ring-orange/10 2xl:h-[50px] 2xl:max-w-[640px] 2xl:pl-5"
        >
          <input
            name="q"
            type="search"
            [value]="searchTerm()"
            (input)="onSearchInput($event)"
            (focus)="onSearchFocus()"
            (blur)="onSearchBlur()"
            class="min-w-0 flex-1 border-none bg-transparent p-0 text-[14px] outline-none placeholder:text-[#555] 2xl:text-[15px]"
            placeholder="What are you looking for today?"
            aria-label="Search products"
          />
          <button
            type="submit"
            class="mr-2 grid h-8 w-8 place-items-center rounded-full text-[#333] hover:bg-[#f4f4f5] hover:text-orange 2xl:mr-3 2xl:h-10 2xl:w-10"
            aria-label="Search"
          >
            <svg
              class="h-5 w-5 2xl:h-7 2xl:w-7"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="10.5" cy="10.5" r="6.5" />
              <path d="m16 16 4.5 4.5" />
            </svg>
          </button>
          @if (isSearchOpen()) {
            <!--
              Bounded and scrollable. With three groups the list can reach sixteen rows, and
              `overflow-hidden` with no height cap let it run off the bottom of the screen — the
              last group was cut in half with nothing to say more was there. Capped at the smaller
              of 70% of the viewport and 26rem, so it never swallows the page on a laptop and never
              overflows a short window on a phone. `overscroll-contain` stops a scroll that reaches
              the end of the list from carrying on into the page behind it.
            -->
            <div
              class="absolute left-0 right-0 top-[calc(100%+8px)] z-[130] max-h-[min(70vh,26rem)] overflow-y-auto overscroll-contain rounded-xl border border-[#e5e5e8] bg-white shadow-[0_18px_45px_rgba(17,17,17,0.14)]"
              role="listbox"
              aria-label="Search results"
              (mousedown)="$event.preventDefault()"
            >
              @if (isSearching()) {
                <p class="px-4 py-3 text-sm text-black/55">Searching…</p>
              } @else if (searchResults().length === 0) {
                <p class="px-4 py-3 text-sm text-black/55">Nothing found</p>
              } @else {
                <!--
                  Grouped rather than one flat list. The search returns stores, coupon categories
                  and product collections, and the same name can be two different pages —
                  "Fashion" the category lists coupons, "Fashion" the collection lists products.
                  A flat list would give a searcher no way to tell which one they were opening,
                  so each group carries a heading and each row says where it leads.
                -->
                @for (group of searchGroups(); track group.label) {
                  <!-- Sticky, so while scrolling the list you can still see which group you are
                       in. Without it the headings scroll away and the rows lose their meaning. -->
                  <p
                    class="sticky top-0 z-10 border-t border-[#f0eef3] bg-[#faf8fc] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.06em] text-black/45 first:border-t-0"
                  >
                    {{ group.label }}
                  </p>
                  @for (result of group.results; track result.path + result.name) {
                    <a
                      class="flex items-center gap-3 px-4 py-2.5 hover:bg-[#f6f2fa]"
                      role="option"
                      [attr.aria-selected]="false"
                      [routerLink]="result.path"
                      (click)="onResultClick()"
                    >
                      <span
                        class="grid h-8 w-8 shrink-0 place-items-center overflow-hidden rounded-full bg-[#f1eaf7]"
                        aria-hidden="true"
                      >
                        <!-- The wrapper is aria-hidden and the name follows as text, so decorative. -->
                        <app-store-logo [logoUrl]="result.logoUrl" [name]="result.name" decorative />
                      </span>
                      <span class="min-w-0">
                        <span class="block truncate text-sm font-medium text-[#333]">{{
                          result.name
                        }}</span>
                        <span class="block text-[11px] text-black/45">{{ group.kind }}</span>
                      </span>
                    </a>
                  }
                }
              }
            </div>
          }
        </form>
        <div
          class="ml-auto flex shrink-0 items-center gap-4 text-[11px] text-[#111] 2xl:gap-7 2xl:text-[12px]"
        >
          <!--
            Track order / Account / Wishlist go with the Shop's master switch.

            They are shop furniture — ordering, signing in, saving to a list — and on a site whose
            Shop is switched off there is nothing to track, no account to hold and nothing to save.
            Deals below stays: it is the affiliate side of the site and has its own page.
          -->
          @if (shopEnabled()) {
            <a
              routerLink="/storelist"
              class="flex flex-col items-center gap-0.5 hover:text-orange 2xl:gap-1"
              ><svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <path d="M3 7h11v10H3z" />
                <path d="M14 10h4l3 3v4h-7z" />
                <circle cx="7" cy="19" r="1.5" />
                <circle cx="18" cy="19" r="1.5" /></svg
              ><span>Track order</span></a
            >
            <a
              routerLink="/contact-us"
              class="flex flex-col items-center gap-0.5 hover:text-orange 2xl:gap-1"
              ><svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <path d="M20 21a8 8 0 0 0-16 0" />
                <circle cx="12" cy="7" r="4" /></svg
              ><span>Account</span></a
            >
            <a
              routerLink="/coupons"
              class="flex flex-col items-center gap-0.5 hover:text-orange 2xl:gap-1"
              ><svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <path
                  d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"
                /></svg
              ><span>Wishlist</span></a
            >
          }
          <!--
            Deals, as an actual button.

            It used to be a 20px icon with an 11px caption stacked under it, sitting beside an
            identically sized Blog icon — two whispers where the header has room for one clear
            call to action. Blog is gone from here (it is in the topbar and the nav row below), and
            Deals gets the weight instead: icon and label on one line, in a filled pill.
          -->
          <a
            routerLink="/collection"
            class="flex items-center gap-2 rounded-full bg-orange px-4 py-2 text-[13px] font-semibold text-white transition hover:bg-orange/90 2xl:gap-2.5 2xl:px-5 2xl:py-2.5 2xl:text-[14px]"
            ><svg
              class="h-[18px] w-[18px] shrink-0 2xl:h-5 2xl:w-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h7.72a2 2 0 0 0 2-1.61L21 6H6" /></svg
            ><span>Deals</span></a
          >
        </div>
      </div>
      <!-- Mobile row -->
      <div class="py-3 xl:hidden">
        <div class="flex h-12 items-center justify-between gap-3">
          <!-- Logo now has the row to itself apart from the menu button, so it takes the space the
               three utility links used to compete for. -->
          <!-- 244px is what a 360px phone leaves after the 7.5% gutters, the 44px menu button and
               the gap between them. `min-w-0` + `max-w-full` let it shrink below that on a 320px
               screen rather than pushing the button off the row. -->
          <a routerLink="/" class="flex h-12 min-w-0 items-center" aria-label="SavingArena home">
            <svg
              class="w-[244px] max-w-full"
              viewBox="0 0 305 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M15.646 12.37H9.03797C3.52197 12.37 0.749974 10.634 0.749974 7.16199V6.06999C0.749974 2.56999 3.52197 0.861987 9.03797 0.861987H11.838C12.734 0.861987 12.93 1.36599 12.93 2.37399C12.93 3.38199 12.734 3.88599 11.838 3.88599H8.95397C5.67797 3.88599 4.44597 4.83799 4.44597 6.06999V7.16199C4.44597 8.36599 5.67797 9.34599 8.95397 9.34599H15.562C21.078 9.34599 23.85 11.082 23.85 14.554V15.954C23.85 19.454 21.078 21.162 15.562 21.162H1.84197C0.945974 21.162 0.749974 20.658 0.749974 19.65C0.749974 18.642 0.945974 18.138 1.84197 18.138H15.646C18.922 18.138 20.154 17.186 20.154 15.954V14.554C20.154 13.35 18.922 12.37 15.646 12.37ZM41.1853 0.777986C42.2773 0.777986 42.9213 1.14199 43.3693 1.75799L55.5773 19.174C55.7173 19.398 55.7733 19.622 55.7733 19.818C55.7733 20.658 54.6813 21.302 53.7293 21.302C53.2253 21.302 52.7773 21.134 52.4973 20.742L49.1933 15.926H33.6253L30.5173 20.742C30.2653 21.134 29.7893 21.302 29.3133 21.302C28.3893 21.302 27.2973 20.658 27.2973 19.79C27.2973 19.566 27.3813 19.37 27.4933 19.174L38.9733 1.75799C39.3933 1.14199 40.0653 0.777986 41.1853 0.777986ZM41.1853 4.19399L35.5573 12.902H47.1213L41.1853 4.19399ZM67.8213 21.274C66.7293 21.274 66.0853 20.938 65.6373 20.294L53.3173 2.87799C53.1773 2.65399 53.0933 2.45799 53.0933 2.23399C53.0933 1.42199 54.2693 0.749986 55.2493 0.749986C55.7253 0.749986 56.3133 0.917986 56.5933 1.33799L67.9053 17.606L79.1053 1.33799C79.3573 0.945986 79.8053 0.749986 80.3373 0.749986C81.2893 0.749986 82.4373 1.39399 82.4373 2.26199C82.4373 2.48599 82.3533 2.70999 82.2133 2.87799L70.0333 20.294C69.5853 20.938 68.9133 21.274 67.8213 21.274ZM90.6208 2.06599V19.958C90.6208 21.022 89.9768 21.274 88.7448 21.274C87.5408 21.274 86.8968 21.022 86.8968 19.958V2.06599C86.8968 1.00199 87.5408 0.749986 88.7448 0.749986C89.9768 0.749986 90.6208 1.00199 90.6208 2.06599ZM119.393 21.274C118.385 21.274 118.161 21.134 117.181 20.322L99.7645 5.64999V19.958C99.7645 21.022 99.1205 21.274 97.8885 21.274C96.6845 21.274 96.0405 21.022 96.0405 19.958V2.06599C96.0405 1.02999 96.6565 0.749986 97.8045 0.749986C99.0365 0.749986 99.5685 1.05799 100.437 1.78599L117.601 16.402V2.06599C117.601 1.00199 118.245 0.749986 119.449 0.749986C120.681 0.749986 121.325 1.00199 121.325 2.06599V19.958C121.325 21.05 120.681 21.274 119.393 21.274ZM151.595 10.97V15.954C151.595 19.51 148.683 21.162 143.279 21.162H134.795C129.279 21.162 126.507 19.426 126.507 15.954V6.06999C126.507 2.56999 129.279 0.861987 134.795 0.861987H138.743C139.639 0.861987 139.835 1.36599 139.835 2.37399C139.835 3.38199 139.639 3.88599 138.743 3.88599H134.907C131.631 3.88599 130.203 4.83799 130.203 6.06999V15.954C130.203 17.158 131.631 18.138 134.907 18.138H143.167C146.443 18.138 147.843 17.158 147.843 15.954V10.97C147.843 9.87799 148.459 9.65399 149.691 9.65399C150.923 9.65399 151.595 9.87799 151.595 10.97ZM168.634 0.777986C169.726 0.777986 170.37 1.14199 170.818 1.75799L183.026 19.174C183.166 19.398 183.222 19.622 183.222 19.818C183.222 20.658 182.13 21.302 181.178 21.302C180.674 21.302 180.226 21.134 179.946 20.742L176.642 15.926H161.074L157.966 20.742C157.714 21.134 157.238 21.302 156.762 21.302C155.838 21.302 154.746 20.658 154.746 19.79C154.746 19.566 154.83 19.37 154.942 19.174L166.422 1.75799C166.842 1.14199 167.514 0.777986 168.634 0.777986ZM168.634 4.19399L163.006 12.902H174.57L168.634 4.19399ZM187.675 2.14999C187.675 1.28199 188.095 0.861987 188.991 0.861987H204.727C209.795 0.861987 212.959 2.65399 212.959 5.39799V8.92599C212.959 11.67 209.795 13.462 204.727 13.462H203.607C200.303 13.462 198.959 13.434 197.503 13.35V13.406C198.707 13.854 199.995 14.274 204.251 15.982L210.999 18.698C211.643 18.95 211.895 19.342 211.895 19.958C211.895 20.966 211.223 21.274 209.991 21.274C209.459 21.274 208.367 21.218 207.779 20.882L191.399 13.798V19.958C191.399 21.022 190.755 21.274 189.523 21.274C188.319 21.274 187.675 21.022 187.675 19.958V2.14999ZM204.391 3.88599H191.399V10.494H204.391C208.199 10.494 209.263 9.70999 209.263 8.70199V5.67799C209.263 4.66999 208.199 3.88599 204.391 3.88599ZM239.681 12.678H221.509V15.954C221.509 17.158 222.937 18.138 226.213 18.138H239.597C240.493 18.138 240.689 18.642 240.689 19.65C240.689 20.63 240.493 21.162 239.597 21.162H226.101C220.585 21.162 217.813 19.426 217.813 15.954V6.06999C217.813 2.56999 220.585 0.861987 226.101 0.861987H230.273C231.141 0.861987 231.337 1.36599 231.337 2.37399C231.337 3.38199 231.141 3.88599 230.273 3.88599H226.213C222.937 3.88599 221.509 4.83799 221.509 6.06999V9.65399H239.681C240.577 9.65399 240.773 10.158 240.773 11.166C240.773 12.174 240.577 12.678 239.681 12.678ZM269.182 21.274C268.174 21.274 267.95 21.134 266.97 20.322L249.554 5.64999V19.958C249.554 21.022 248.91 21.274 247.678 21.274C246.474 21.274 245.83 21.022 245.83 19.958V2.06599C245.83 1.02999 246.446 0.749986 247.594 0.749986C248.826 0.749986 249.358 1.05799 250.226 1.78599L267.39 16.402V2.06599C267.39 1.00199 268.034 0.749986 269.238 0.749986C270.47 0.749986 271.114 1.00199 271.114 2.06599V19.958C271.114 21.05 270.47 21.274 269.182 21.274ZM289.456 0.777986C290.548 0.777986 291.192 1.14199 291.64 1.75799L303.848 19.174C303.988 19.398 304.044 19.622 304.044 19.818C304.044 20.658 302.952 21.302 302 21.302C301.496 21.302 301.048 21.134 300.768 20.742L297.464 15.926H281.896L278.788 20.742C278.536 21.134 278.06 21.302 277.584 21.302C276.66 21.302 275.568 20.658 275.568 19.79C275.568 19.566 275.652 19.37 275.764 19.174L287.244 1.75799C287.664 1.14199 288.336 0.777986 289.456 0.777986ZM289.456 4.19399L283.828 12.902H295.392L289.456 4.19399Z"
                fill="#741FA2"
              />
            </svg>
          </a>
          <!-- Menu button. 44px square, which is the smallest comfortable tap target. -->
          <button
            type="button"
            class="grid h-11 w-11 shrink-0 place-items-center rounded-lg border border-[#e2ddea] text-[#2d123f] transition hover:bg-[#faf7fc]"
            (click)="toggleMobileMenu()"
            [attr.aria-expanded]="isMobileMenuOpen()"
            aria-controls="sav-mobile-menu"
            [attr.aria-label]="isMobileMenuOpen() ? 'Close menu' : 'Open menu'"
          >
            @if (isMobileMenuOpen()) {
              <svg viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6" aria-hidden="true">
                <path
                  d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                ></path>
              </svg>
            } @else {
              <svg viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6" aria-hidden="true">
                <path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"></path>
              </svg>
            }
          </button>
        </div>
        <form
          role="search"
          (submit)="onSearchSubmit($event)"
          class="relative mt-3 h-11 rounded-[10px] border border-[#cfcfd3] bg-white"
        >
          <input
            name="q"
            type="search"
            [value]="searchTerm()"
            (input)="onSearchInput($event)"
            (focus)="onSearchFocus()"
            (blur)="onSearchBlur()"
            class="h-full w-full bg-transparent pl-4 pr-12 text-[14px] outline-none placeholder:text-[#555]"
            placeholder="What are you looking for today?"
            aria-label="Search products"
          />
          <button
            type="submit"
            class="absolute right-2 top-1/2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-full text-[#333] hover:bg-[#f4f4f5] hover:text-orange"
            aria-label="Search"
          >
            <svg
              class="h-5 w-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="10.5" cy="10.5" r="6.5" />
              <path d="m16 16 4.5 4.5" />
            </svg>
          </button>

          <!-- Suggestions. This existed only on the desktop search field, so on a phone typing
               populated `searchResults()` and nothing was ever rendered — the box looked dead
               unless you guessed that Enter still worked. Same markup as the desktop dropdown. -->
          @if (isSearchOpen()) {
            <!--
              Bounded and scrollable. With three groups the list can reach sixteen rows, and
              `overflow-hidden` with no height cap let it run off the bottom of the screen — the
              last group was cut in half with nothing to say more was there. Capped at the smaller
              of 70% of the viewport and 26rem, so it never swallows the page on a laptop and never
              overflows a short window on a phone. `overscroll-contain` stops a scroll that reaches
              the end of the list from carrying on into the page behind it.
            -->
            <div
              class="absolute left-0 right-0 top-[calc(100%+8px)] z-[130] max-h-[min(70vh,26rem)] overflow-y-auto overscroll-contain rounded-xl border border-[#e5e5e8] bg-white shadow-[0_18px_45px_rgba(17,17,17,0.14)]"
              role="listbox"
              aria-label="Search results"
              (mousedown)="$event.preventDefault()"
            >
              <!-- The same grouped results as the desktop panel. This one had been left on the
                   old flat store-only list, so a phone search showed no categories or
                   collections at all. -->
              @if (isSearching()) {
                <p class="px-4 py-3 text-sm text-black/55">Searching…</p>
              } @else if (searchResults().length === 0) {
                <p class="px-4 py-3 text-sm text-black/55">Nothing found</p>
              } @else {
                @for (group of searchGroups(); track group.label) {
                  <p
                    class="sticky top-0 z-10 border-t border-[#f0eef3] bg-[#faf8fc] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.06em] text-black/45 first:border-t-0"
                  >
                    {{ group.label }}
                  </p>
                  @for (result of group.results; track result.path + result.name) {
                    <a
                      class="flex items-center gap-3 px-4 py-3 hover:bg-[#f6f2fa]"
                      role="option"
                      [attr.aria-selected]="false"
                      [routerLink]="result.path"
                      (click)="onResultClick(); closeMobileMenu()"
                    >
                      <span
                        class="grid h-8 w-8 shrink-0 place-items-center overflow-hidden rounded-full bg-[#f1eaf7]"
                        aria-hidden="true"
                      >
                        <!-- The wrapper is aria-hidden and the name follows as text, so decorative. -->
                        <app-store-logo [logoUrl]="result.logoUrl" [name]="result.name" decorative />
                      </span>
                      <span class="min-w-0">
                        <span class="block truncate text-sm font-medium text-[#333]">{{
                          result.name
                        }}</span>
                        <span class="block text-[11px] text-black/45">{{ group.kind }}</span>
                      </span>
                    </a>
                  }
                }
              }
            </div>
          }
        </form>

        <!-- Phone nav. Carries the same destinations as the desktop bar (which is `xl:flex`, so it
             never renders here) plus the three utility links that used to sit beside the logo.
             Every link closes the drawer, since the route changes underneath it. -->
        @if (isMobileMenuOpen()) {
          <nav id="sav-mobile-menu" class="sav-mobile-menu" aria-label="Mobile">
            <a routerLink="/categories" (click)="closeMobileMenu()">Categories</a>
            <a routerLink="/storelist" (click)="closeMobileMenu()">Top Stores</a>
            <!-- Hidden while the Shop is switched off in admin, when /shop answers 404. -->
            @if (shopEnabled()) {
              <a routerLink="/shop" (click)="closeMobileMenu()">Shop</a>
            }
            <a routerLink="/blogs" (click)="closeMobileMenu()">Blog</a>
            <a routerLink="/coupons" (click)="closeMobileMenu()">Coupons</a>
            <a routerLink="/collection" (click)="closeMobileMenu()">Deals</a>

            <!-- The phone's copies of the header's Track / Account buttons, so they come and go
                 with the Shop for the same reason — including the rule above them, which would
                 otherwise be a divider with nothing under it. -->
            @if (shopEnabled()) {
              <span class="sav-mobile-menu-rule" aria-hidden="true"></span>

              <a routerLink="/storelist" (click)="closeMobileMenu()">Track</a>
              <a routerLink="/contact-us" (click)="closeMobileMenu()">Account</a>
            }
          </nav>
        }
      </div>
      <!-- Main nav: same white bar treatment as the rest of the header (dark links, orange hover). -->
      <nav
        class="hidden h-[38px] items-center justify-between text-[14px] text-[#333] xl:flex 2xl:h-[42px] 2xl:text-[15px]"
        aria-label="Main"
      >
        <div class="flex h-full items-center gap-3 xl:gap-4 2xl:gap-7">
          <a
            routerLink="/categories"
            class="flex h-full shrink-0 items-center border-b-2 border-transparent transition hover:border-orange hover:text-orange"
            >Categories</a
          >
          <a
            routerLink="/storelist"
            class="flex h-full shrink-0 items-center border-b-2 border-transparent transition hover:border-orange hover:text-orange"
            >Top Stores</a
          >
          <!-- Same switch as the phone drawer: no link to a Shop that is off the site. -->
          @if (shopEnabled()) {
            <a
              routerLink="/shop"
              class="flex h-full shrink-0 items-center border-b-2 border-transparent font-semibold text-orange transition hover:border-orange"
              >Shop</a
            >
          }
          <a
            routerLink="/blogs"
            class="flex h-full shrink-0 items-center border-b-2 border-transparent transition hover:border-orange hover:text-orange"
            >Blog</a
          >
          <a
            routerLink="/coupons"
            class="flex h-full shrink-0 items-center border-b-2 border-transparent transition hover:border-orange hover:text-orange"
            >Coupons</a
          >

          <!--
            Collections: the categories that have a /collection/:slug page. The list comes from
            the API, which returns only categories with enough active products to qualify, so every
            entry here opens a real page. Loaded on first hover/focus (see `loadDealCollections`).
          -->
          <div
            class="group relative flex h-full items-center"
            (mouseenter)="loadDealCollections()"
            (focusin)="loadDealCollections()"
          >
            <button
              type="button"
              class="flex h-full shrink-0 items-center border-b-2 border-transparent transition hover:border-orange hover:text-orange group-hover:border-orange group-hover:text-orange"
              aria-label="Open collections menu"
            >
              Collections
            </button>
            <div
              class="invisible absolute left-0 top-full z-[120] w-[min(760px,calc(100vw-2rem))] translate-y-2 rounded-b-2xl border border-[#dedee1] bg-white p-6 opacity-0 shadow-[0_24px_55px_rgba(17,17,17,0.14)] transition group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 group-focus-within:opacity-100"
            >
              @if (isDealCollectionsLoading()) {
                <p class="text-xs font-semibold text-[#777]" aria-live="polite">
                  Loading collections…
                </p>
              } @else if (dealCollections().length) {
                <div class="grid grid-cols-3 gap-x-6 gap-y-1">
                  @for (collection of dealCollections(); track collection.path) {
                    <a
                      [routerLink]="collection.path"
                      class="flex items-center gap-3 rounded-xl px-2 py-2 transition hover:bg-[#faf7fc]"
                    >
                      @if (collection.imageUrl) {
                        <img
                          [src]="collection.imageUrl"
                          alt=""
                          class="h-9 w-9 shrink-0 rounded-lg object-cover"
                          loading="lazy"
                        />
                      }
                      <span class="min-w-0">
                        <span class="block truncate text-sm text-[#333]">{{
                          collection.label
                        }}</span>
                        <span class="block text-[11px] text-[#888]"
                          >{{ collection.productCount }} products</span
                        >
                      </span>
                    </a>
                  }
                </div>
                <a
                  routerLink="/collection"
                  class="mt-3 inline-block border-t border-[#eee] pt-3 text-sm font-semibold text-orange"
                  >Browse all deals →</a
                >
              } @else {
                <!-- No category has enough products to have a page yet. -->
                <p class="text-sm text-[#777]">
                  No deal collections yet.
                  <a routerLink="/collection" class="font-semibold text-orange">Browse all deals</a>
                </p>
              }
            </div>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-3 2xl:gap-4" aria-label="Promotions">
          <!--
            Both promo links follow the current featured event (FeaturedEventService). The deals link
            appears only when that event actually has a deals page — its stores need enough products —
            so an absent page means no link rather than the hardcoded `href="#"` this replaced. The
            divider only renders when both links are present.
          -->
          @if (featuredEventDealsPath(); as dealsPath) {
            <a
              [routerLink]="dealsPath"
              class="text-[12px] font-medium text-[#555] transition hover:text-orange 2xl:text-[13px]"
              >{{ featuredEventDealsLabel() }}</a
            >
          }
          @if (featuredEventDealsPath() && featuredEventPath()) {
            <span class="h-3.5 w-px shrink-0 bg-[#d6d0dc]" aria-hidden="true"></span>
          }
          @if (featuredEventPath(); as couponPath) {
            <a
              [routerLink]="couponPath"
              class="text-[12px] font-medium text-[#555] transition hover:text-orange 2xl:text-[13px]"
              >{{ featuredEventLabel() }}</a
            >
          }
        </div>
      </nav>
    </div>
  </header>

  <main class="sav-site-main">
    <router-outlet />
  </main>

  <footer class="sav-site-footer">
    <div class="sav-footer-wrap">
      <section class="sav-footer-top-row">
        <div class="sav-footer-brand-col">
          <a routerLink="/" class="sav-footer-logo" aria-label="SavingArena">
            <svg
              class="sav-brand-logo-svg"
              width="305"
              height="23"
              viewBox="0 0 305 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M15.646 12.37H9.03797C3.52197 12.37 0.749974 10.634 0.749974 7.16199V6.06999C0.749974 2.56999 3.52197 0.861987 9.03797 0.861987H11.838C12.734 0.861987 12.93 1.36599 12.93 2.37399C12.93 3.38199 12.734 3.88599 11.838 3.88599H8.95397C5.67797 3.88599 4.44597 4.83799 4.44597 6.06999V7.16199C4.44597 8.36599 5.67797 9.34599 8.95397 9.34599H15.562C21.078 9.34599 23.85 11.082 23.85 14.554V15.954C23.85 19.454 21.078 21.162 15.562 21.162H1.84197C0.945974 21.162 0.749974 20.658 0.749974 19.65C0.749974 18.642 0.945974 18.138 1.84197 18.138H15.646C18.922 18.138 20.154 17.186 20.154 15.954V14.554C20.154 13.35 18.922 12.37 15.646 12.37ZM41.1853 0.777986C42.2773 0.777986 42.9213 1.14199 43.3693 1.75799L55.5773 19.174C55.7173 19.398 55.7733 19.622 55.7733 19.818C55.7733 20.658 54.6813 21.302 53.7293 21.302C53.2253 21.302 52.7773 21.134 52.4973 20.742L49.1933 15.926H33.6253L30.5173 20.742C30.2653 21.134 29.7893 21.302 29.3133 21.302C28.3893 21.302 27.2973 20.658 27.2973 19.79C27.2973 19.566 27.3813 19.37 27.4933 19.174L38.9733 1.75799C39.3933 1.14199 40.0653 0.777986 41.1853 0.777986ZM41.1853 4.19399L35.5573 12.902H47.1213L41.1853 4.19399ZM67.8213 21.274C66.7293 21.274 66.0853 20.938 65.6373 20.294L53.3173 2.87799C53.1773 2.65399 53.0933 2.45799 53.0933 2.23399C53.0933 1.42199 54.2693 0.749986 55.2493 0.749986C55.7253 0.749986 56.3133 0.917986 56.5933 1.33799L67.9053 17.606L79.1053 1.33799C79.3573 0.945986 79.8053 0.749986 80.3373 0.749986C81.2893 0.749986 82.4373 1.39399 82.4373 2.26199C82.4373 2.48599 82.3533 2.70999 82.2133 2.87799L70.0333 20.294C69.5853 20.938 68.9133 21.274 67.8213 21.274ZM90.6208 2.06599V19.958C90.6208 21.022 89.9768 21.274 88.7448 21.274C87.5408 21.274 86.8968 21.022 86.8968 19.958V2.06599C86.8968 1.00199 87.5408 0.749986 88.7448 0.749986C89.9768 0.749986 90.6208 1.00199 90.6208 2.06599ZM119.393 21.274C118.385 21.274 118.161 21.134 117.181 20.322L99.7645 5.64999V19.958C99.7645 21.022 99.1205 21.274 97.8885 21.274C96.6845 21.274 96.0405 21.022 96.0405 19.958V2.06599C96.0405 1.02999 96.6565 0.749986 97.8045 0.749986C99.0365 0.749986 99.5685 1.05799 100.437 1.78599L117.601 16.402V2.06599C117.601 1.00199 118.245 0.749986 119.449 0.749986C120.681 0.749986 121.325 1.00199 121.325 2.06599V19.958C121.325 21.05 120.681 21.274 119.393 21.274ZM151.595 10.97V15.954C151.595 19.51 148.683 21.162 143.279 21.162H134.795C129.279 21.162 126.507 19.426 126.507 15.954V6.06999C126.507 2.56999 129.279 0.861987 134.795 0.861987H138.743C139.639 0.861987 139.835 1.36599 139.835 2.37399C139.835 3.38199 139.639 3.88599 138.743 3.88599H134.907C131.631 3.88599 130.203 4.83799 130.203 6.06999V15.954C130.203 17.158 131.631 18.138 134.907 18.138H143.167C146.443 18.138 147.843 17.158 147.843 15.954V10.97C147.843 9.87799 148.459 9.65399 149.691 9.65399C150.923 9.65399 151.595 9.87799 151.595 10.97ZM168.634 0.777986C169.726 0.777986 170.37 1.14199 170.818 1.75799L183.026 19.174C183.166 19.398 183.222 19.622 183.222 19.818C183.222 20.658 182.13 21.302 181.178 21.302C180.674 21.302 180.226 21.134 179.946 20.742L176.642 15.926H161.074L157.966 20.742C157.714 21.134 157.238 21.302 156.762 21.302C155.838 21.302 154.746 20.658 154.746 19.79C154.746 19.566 154.83 19.37 154.942 19.174L166.422 1.75799C166.842 1.14199 167.514 0.777986 168.634 0.777986ZM168.634 4.19399L163.006 12.902H174.57L168.634 4.19399ZM187.675 2.14999C187.675 1.28199 188.095 0.861987 188.991 0.861987H204.727C209.795 0.861987 212.959 2.65399 212.959 5.39799V8.92599C212.959 11.67 209.795 13.462 204.727 13.462H203.607C200.303 13.462 198.959 13.434 197.503 13.35V13.406C198.707 13.854 199.995 14.274 204.251 15.982L210.999 18.698C211.643 18.95 211.895 19.342 211.895 19.958C211.895 20.966 211.223 21.274 209.991 21.274C209.459 21.274 208.367 21.218 207.779 20.882L191.399 13.798V19.958C191.399 21.022 190.755 21.274 189.523 21.274C188.319 21.274 187.675 21.022 187.675 19.958V2.14999ZM204.391 3.88599H191.399V10.494H204.391C208.199 10.494 209.263 9.70999 209.263 8.70199V5.67799C209.263 4.66999 208.199 3.88599 204.391 3.88599ZM239.681 12.678H221.509V15.954C221.509 17.158 222.937 18.138 226.213 18.138H239.597C240.493 18.138 240.689 18.642 240.689 19.65C240.689 20.63 240.493 21.162 239.597 21.162H226.101C220.585 21.162 217.813 19.426 217.813 15.954V6.06999C217.813 2.56999 220.585 0.861987 226.101 0.861987H230.273C231.141 0.861987 231.337 1.36599 231.337 2.37399C231.337 3.38199 231.141 3.88599 230.273 3.88599H226.213C222.937 3.88599 221.509 4.83799 221.509 6.06999V9.65399H239.681C240.577 9.65399 240.773 10.158 240.773 11.166C240.773 12.174 240.577 12.678 239.681 12.678ZM269.182 21.274C268.174 21.274 267.95 21.134 266.97 20.322L249.554 5.64999V19.958C249.554 21.022 248.91 21.274 247.678 21.274C246.474 21.274 245.83 21.022 245.83 19.958V2.06599C245.83 1.02999 246.446 0.749986 247.594 0.749986C248.826 0.749986 249.358 1.05799 250.226 1.78599L267.39 16.402V2.06599C267.39 1.00199 268.034 0.749986 269.238 0.749986C270.47 0.749986 271.114 1.00199 271.114 2.06599V19.958C271.114 21.05 270.47 21.274 269.182 21.274ZM289.456 0.777986C290.548 0.777986 291.192 1.14199 291.64 1.75799L303.848 19.174C303.988 19.398 304.044 19.622 304.044 19.818C304.044 20.658 302.952 21.302 302 21.302C301.496 21.302 301.048 21.134 300.768 20.742L297.464 15.926H281.896L278.788 20.742C278.536 21.134 278.06 21.302 277.584 21.302C276.66 21.302 275.568 20.658 275.568 19.79C275.568 19.566 275.652 19.37 275.764 19.174L287.244 1.75799C287.664 1.14199 288.336 0.777986 289.456 0.777986ZM289.456 4.19399L283.828 12.902H295.392L289.456 4.19399Z"
                fill="#741FA2"
              />
            </svg>
          </a>
          <p class="sav-footer-tagline">
            Coupon, deals, and smart savings, simple and transparent.
          </p>

          <!--
            SavingArena's real profiles. All four of these were `href="#"` — a dead link in the
            footer of every page on the site, which is both a bad click and something a crawler
            counts against the site.

            `target="_blank"` because leaving the site is the point, and `rel="noopener noreferrer"`
            with it: without noopener the opened page can reach back through `window.opener`.

            The Pinterest icon that used to sit here is gone rather than guessed at. The other three
            are the brand's live, verified accounts; there is no Pinterest URL to point at, and a
            made-up one would be the same dead link in a new costume. Add it back when there is a
            real handle — the site also has live TikTok and YouTube accounts that could join it.
          -->
          <div class="sav-footer-socials" aria-label="Social media">
            <a
              href="https://www.facebook.com/Savingarena"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SavingArena on Facebook"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </a>
            <a
              href="https://x.com/savingarena"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SavingArena on X"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/savingarena/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SavingArena on Instagram"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
          </div>

          <a href="mailto:support@savingarena.com" class="sav-support-email"
            >support@savingarena.com</a
          >
          <p class="sav-trust-copy">Trusted savings, curated daily.</p>
        </div>

        <div class="sav-footer-newsletter-col">
          <!-- h2, not h3. The footer sits on every page, so its level has to be one that works under
             any page outline. As an h3 it followed pages whose deepest heading was h1 or h2, which
             skipped a level site-wide; as an h2 it is a sibling of the page's own sections. -->
          <h2>Sign up for the latest deals</h2>
          @if (signup.subscribed()) {
            <p class="sav-footer-newsletter-done" role="status">
              You're on the list — deals are on the way!
            </p>
          } @else {
            <form
              class="sav-footer-newsletter-form"
              [formGroup]="signup.form"
              (ngSubmit)="signup.submit('footer')"
              novalidate
            >
              <div class="sav-honeypot" aria-hidden="true">
                <label
                  >Company website<input
                    formControlName="companyWebsite"
                    type="text"
                    tabindex="-1"
                    autocomplete="off"
                /></label>
              </div>
              <input
                formControlName="email"
                type="email"
                placeholder="Enter Your Email"
                aria-label="Email address"
                autocomplete="email"
              />
              <button type="submit" [disabled]="signup.submitting()">
                {{ signup.submitting() ? '…' : 'SUBSCRIBE' }}
              </button>
            </form>
            @if (signup.showEmailError()) {
              <span class="sav-footer-newsletter-error">Enter a valid email address.</span>
            } @else if (signup.error()) {
              <span class="sav-footer-newsletter-error">{{ signup.error() }}</span>
            }
          }
          <p>Never Miss Another Deal! Subscribe Today!</p>
        </div>
      </section>

      <!--
        Built from `footerGroups` rather than written out here, so every link is a route that
        exists. The Popular Stores column is admin-driven (home page Top Stores) and drops out
        entirely when the admin has picked none.
      -->
      <section class="sav-footer-links-grid" aria-label="Footer links">
        @for (group of footerGroups(); track group.label) {
          <div>
            <!-- h2 for the same reason as the newsletter heading above: these are site-level
                 navigation groups on every page, so they cannot assume a page has gone as deep as
                 h3 before them. As h4s they skipped a level on every page on the site. -->
            <h2>{{ group.label }}</h2>
            @for (link of group.links; track link.path) {
              <a [routerLink]="link.path">{{ link.label }}</a>
            }
          </div>
        }
      </section>

      <!--
        The legal bar. Separated from the link columns by a rule, because everything above it is
        somewhere a reader might want to go and everything in it is something they might need to
        check. Mixing the two made the Company column eleven items long and hid the policies inside
        it.
      -->
      <div class="sav-footer-legal">
        <nav class="sav-footer-legal-links" aria-label="Legal">
          @for (link of legalLinks; track link.path) {
            <a [routerLink]="link.path">{{ link.label }}</a>
          }
          <!--
            A <button>, not an anchor: it reopens the cookie banner rather than going anywhere. It
            sits here because this is where the Cookie Policy tells readers to find it.
          -->
          <button type="button" class="sav-cookie-settings" (click)="reopenCookieSettings()">
            Cookie settings
          </button>
        </nav>

        <div class="sav-footer-legal-meta">
          <p class="sav-footer-legal-copy">
            &copy; {{ currentYear }} SavingArena. All rights reserved. Third-party trademarks belong
            to their respective owners. Using affiliate links may earn a commission, at no extra
            cost to you.
          </p>
          <!--
            Build credit. `noopener` because it opens a new tab, and that tab must not be handed a
            reference back to this window.
          -->
          <p class="sav-footer-credit">
            Developed and managed by
            <a href="https://baksorbit.com" target="_blank" rel="noopener">BAKSORBIT</a>
          </p>
        </div>
      </div>
    </div>
  </footer>

  <!--
  The SavingArena assistant drawer. Mounted once here rather than on the homepage so a conversation
  started from the homepage field survives navigation — the visitor can open a result and keep the
  thread going.
-->
  <app-ai-chat-panel />

</div>
